
import React from "react";
import { LucideIcon } from "lucide-react";
import { brandColors } from "@/lib/brand";

interface FooterSocialLinkProps {
  href: string;
  icon: LucideIcon | React.FC<{ size?: number; className?: string }>;
  label: string;
}

export const FooterSocialLink = ({
  href,
  icon: Icon,
  label,
}: FooterSocialLinkProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="social-link group"
    >
      <div className="p-2 rounded-full border border-yarn-slate/20 transition-all group-hover:border-primary/40 group-hover:text-primary group-hover:-translate-y-1 duration-300">
        <Icon size={18} className="text-yarn-slate transition-colors group-hover:text-primary" />
        <span className="sr-only">{label}</span>
      </div>
    </a>
  );
};
